import home from "./svg/home-light.2b45eda5.svg";
import about from "./svg/about-light.8cd8f24d.svg";
import portfolio from "./svg/portfolio-light.d7095cbd.svg";
import contact from "./svg/contact-light.1f770f0f.svg";
import homeAlt from "./svg/home-alt.svg";
import aboutAlt from "./svg/about-alt.svg";
import portfolioAlt from "./svg/portfolio-alt.svg";
import contactAlt from "./svg/contact-alt.svg";

const projects = [
  {
    title: "zendii",
    description:
      "Some shitty app I built for some shitty people to meet a shitty purpose.",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description:
      "Some shitty app I built for some shitty people to meet a shitty purpose. Just throwing words around.",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description: "Some shitty app I built for some shitty.",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description:
      "Some shitty app I built for some shitty people to meet a shitty purpose.",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description: "Some shitty app I built for some shitty people to.",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description:
      "Some shitty app I built for some shitty people to meet a shitty purpose.",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description: "Some shitty app I built for some shitty people",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
  {
    title: "zendii",
    description:
      "Some shitty app I built for some shitty people to meet a shitty purpose. Just throwing words around",
    github: "#github",
    client: "DevC Abuja",
    link: "#link",
  },
];

export const navbar = [
  {
    to: "/",
    exact: true,
    icon: home,
    light: homeAlt,
    alt: "home navigation icon",
    text: "home",
  },
  {
    to: "/about",
    icon: about,
    light: aboutAlt,
    alt: "about navigation icon",
    text: "about",
  },
  {
    to: "/portfolio",
    icon: portfolio,
    light: portfolioAlt,
    alt: "portfolio navigation icon",
    text: "portfolio",
  },
  {
    to: "/contact",
    icon: contact,
    light: contactAlt,
    alt: "contact navigation icon",
    text: "contact",
  },
];

export const portfolioPage = {
  projects,
};
